import styled from "styled-components";

export const Container = styled.div`
  padding: 70px 116px;

`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button, a{
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }

`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0 ;
`;

export const ButtonPagination = styled.button`
  background-color: #d3d3d3;
  border: none;
  cursor: pointer;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  color: #fff;

  ${props => props.active && `background-color: #fff;`}
  ${props => props.active && `border: 1px solid var(--color-primary);`}
  ${props => props.active && `color: var(--color-primary);`}
`;
